import { render, staticRenderFns } from "./EditDealerGoods.vue?vue&type=template&id=2268127a&scoped=true&"
import script from "./EditDealerGoods.vue?vue&type=script&lang=ts&"
export * from "./EditDealerGoods.vue?vue&type=script&lang=ts&"
import style0 from "./EditDealerGoods.vue?vue&type=style&index=0&id=2268127a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268127a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
